/** @format */

import { TextField, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Row } from "react-bootstrap";
import Col from "react-bootstrap/cjs/Col";

// import { FaAngleDown } from "react-icons/fa";
import DialogContentText from "@mui/material/DialogContentText";
// import { components } from "react-select";
import Waba from "../../dao/Waba";
import swal from "../../reusables/CustomSwal";
import { useNavigate } from "react-router-dom";

// const TABLE_HEAD = [
//   { id: "count", label: "No.", alignRight: false, sortable: false },
//   { id: "waba_id", label: "WABA ID", alignRight: false, sortable: true },
//   // {id: 'role', label: 'Role', alignRight: false, sortable: true},
// ];

// const DropdownIndicator = (props) => {
//   return (
//     components.DropdownIndicator && (
//       <components.DropdownIndicator {...props}>
//         <FaAngleDown color={"grey"} />
//       </components.DropdownIndicator>
//     )
//   );
// };

const industryOptions = [
  "Information Technology",
  "Marketing",
  "Food and Beverage",
];

export default function WABAForm(props) {
  const navigate = useNavigate();
  const { open, onClose } = props;
  const [wabaId, setWabaId] = useState(null);
  const [wabaName, setWabaName] = useState(null);
  const [wabaDesc, setWabaDesc] = useState(null);
  const [wabaIndustry, setWabaIndustry] = useState("none");
  const [wabaWebsite, setWabaWebsite] = useState(null);

  const reset = () => {
    setWabaId(null);
  };

  const onSubmit = async () => {
    try {
      const body = {
        waba_id: wabaId,
        name: wabaName,
        industry: wabaIndustry,
        description: wabaDesc,
        website: wabaWebsite,
      };

      // console.log("TES", body);

      await swal
        .fire({
          title: "",
          text: "Are you sure you want to create this item?",
          icon: "warning",
          showCancelButton: true,
          confirmButton: "Yes",
          confirmButtonColor: "#3085d6",
          cancelButton: "Cancel",
          // cancelButtonColor: '#d33',
        })
        .then(async (result) => {
          try {
            if (result.isConfirmed) {
              let res = await Waba.addWaba(body);
              if (res.id || res.success) {
                await swal.fire({
                  title: "",
                  text: "Creation Successful",
                  icon: "success",
                });
              }
              handleClose(true);
            } else {
              await swal.fire({
                title: "",
                text: "Creation Failed",
                icon: "error",
              });
            }
          } catch (e) {
            console.error(e);
            await swal.fire({
              title: "",
              text: e.error_message ? e.error_message : "Something Wrong",
              icon: "error",
            });
          }
          await navigate(0);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleClose = (refresh) => {
    reset();
    onClose(refresh);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={() => onClose()}
      >
        <DialogTitle>Add WABA</DialogTitle>
        <DialogContent>
          <DialogContentText>WABA ID</DialogContentText>
          <Row>
            <Col md={12}>
              <TextField
                fullWidth
                onChange={(e) => {
                  setWabaId(e.target.value);
                }}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                placeholder={"Insert WABA ID"}
                InputLabelProps={{ shrink: true }}
              />
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <DialogContentText>Name</DialogContentText>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                onChange={(e) => {
                  setWabaName(e.target.value);
                }}
                fullWidth
                placeholder={"Name"}
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col md={6}>
              <DialogContentText>Industry</DialogContentText>
              {/* <Select
                            options={industryOptions}
                            value={{
                                label: wabaIndustry_label,
                                value: wabaIndustry
                            }}
                            onChange={(option) => {
                                setWabaIndustry(option.value)
                                setWabaIndustry_label(option.label)
                            }}
                        >

                        </Select> */}
              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                value={wabaIndustry}
                onChange={(e) => setWabaIndustry(e.target.value)}
              >
                <MenuItem value="none" selected disabled>
                  Please select an industry...
                </MenuItem>
                {industryOptions.map((i) => {
                  return <MenuItem value={i}>{i}</MenuItem>;
                })}
              </Select>

              {/* <TextField
                            fullWidth
                            onChange={(e) => {
                                setWabaIndustry(e.target.value)
                            }}
                            placeholder={"Industry"}
                            inputLabelProps={{shrink: true}}
                        /> */}
            </Col>
          </Row>
          <Row>
            <DialogContentText>Description</DialogContentText>
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-multiline-static"
              multiline
              minRows={4}
              maxRows={8}
              fullWidth
              onChange={(e) => {
                setWabaDesc(e.target.value);
              }}
              placeholder={"Description"}
              inputLabelProps={{ shrink: true }}
            />
          </Row>
          <Row>
            <DialogContentText>Website</DialogContentText>
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              onChange={(e) => {
                setWabaWebsite(e.target.value);
              }}
              fullWidth
              placeholder={"Website"}
              inputLabelProps={{ shrink: true }}
            />
          </Row>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              await onSubmit();
              // handleClose()
            }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
